import { InStoreEndText, InStoreEndTextRow } from 'common/types';

export const getEmptyEndTextRow = (isHelpText?: boolean) => {
	return {
		text: {
			def: '',
		},
		helpText: isHelpText ?? false,
	};
};

export const getDefaultEndTextRows = () => {
	return [getEmptyEndTextRow(false), getEmptyEndTextRow(true)];
};

export const getLocationEndTextRows = (args: {
	inStoreEndText: InStoreEndText | undefined;
	locationId: string;
	isMainLocation: boolean;
}): InStoreEndTextRow[] | undefined => {
	const { inStoreEndText, locationId, isMainLocation } = args;
	if (isMainLocation) {
		return inStoreEndText?.defaultValue;
	} else {
		return inStoreEndText?.location?.[locationId];
	}
};
